module.exports = __webpack_public_path__ + "8d99fbe16c398e73a8a8fed5b4f82295.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/US.svg
// module id = mZzj
// module chunks = 0